const isLoading = false;
const agents = [];
const clients = [];
const requestArrayInputStatus = []
const requestArrayOutputStatus = []
const inputTransactions = [];
const outputTransactions = [];
const responseInputFilter = [];
const responseOutputFilter = [];
const superArrayInputTransactions = [];
const superArrayOutputTransactions = [];
const transaction = {
    products: [{
        item: {
            product: {}, uuid: "", product_name: "", type: "", price: 0.00, discount: 0.00, final_price: 0.00, isPercentage: false, 
            observation: "", category: "", subcategory: "",
        },
        booking: { product_place: "", observation: "", date: "", time: "", people: "", },
        readonly: false, removed: false,
    }],
    payments: [{
        payment_method: {index:null, name: ""}, value: 0.00, date: "", cv: "", aut:"", pix_id:"", invoice_number: "", customer_name: "", customer_document: "",
        readonly: false, removed: false,
    }],
    general: { id: null, user: { uuid: "", name: "", }, date: "", label: "", open: true, bill_final_value: 0.00, bill_total_value: 0.00, bill_total_discount: 0.00, bill_status: "", },
};

export default {
    agents,
    clients,
    isLoading,
    transaction,
    requestArrayInputStatus,
    requestArrayOutputStatus,
    inputTransactions,
    outputTransactions,
    responseInputFilter,
    responseOutputFilter,
    superArrayInputTransactions,
    superArrayOutputTransactions,
}